import be from './Backend';
import router from '../routes';

let session = {
    code: null,
    Id: null
};

let lastAssignmentCode = undefined;

function process(node) {
    console.log('process', node);
    session.id = node.sessionId;
    switch(node.action.type) {
        case 'ASSIGNMENT_SESSION':
            processAssignmentSession(node);
            break;
        case 'USER':
            processUser(node);
            break;
        case 'USER_INPUT':
            processUserInput(node);
            break;
    }
}

function assignParameters(properties, extend) {
    // parameter naming corrections
    if (properties.chapter) {
        properties.chapterCode = properties.chapter;
        delete properties.chapter;
    }
    if (properties.category) {
        properties.categoryCode = properties.category;
        delete properties.category;
    }
    if (properties.assignmentSessionId) {
        properties.sessionId = properties.assignmentSessionId;
        delete properties.assignmentSessionId;
    }
    if (properties.uitwerknummer) {
        properties.code = properties.uitwerknummer;
        delete properties.uitwerknummer;
    }
    return Object.assign(properties, extend)
}

function processAssignmentSession(node) {
    lastAssignmentCode = node.action.assignmentCode;
    router.push({ name: 'assignment', params: { code: node.action.assignmentCode, sessionId: node.action.assignmentSessionId} });
}

function processUser(node) {
    router.push({ name: node.properties.view, params: assignParameters(node.properties, { orchestration: session, assignmentCodeBeforeTip: lastAssignmentCodeBeforeTip }) });
}

function processUserInput(node) {
    router.push({ name: node.properties.view, params: assignParameters(node.properties, { orchestration: session, options: node.action.options }) });
}

const OrchestrationManager = {
    'start': (orchestrationCode, entryLabel = '') => {

        session.code = orchestrationCode;
        be.MIA.startOrchestration(orchestrationCode, entryLabel).then((node) => {
            console.log('orchestrationResult', node);
            process(node);
        });
    },

    'next': (data = undefined) => {
        return be.MIA.postOrchestrationSession(session.id, data).then(process);
    },
};

export default OrchestrationManager;